import useSideNavCollapse from "@/utils/useSideNavCollapse";
import useAppStore from "./store";

export const useSideNavWidth = () => {
  const sideNavVisible = useAppStore((s) => s.sideNavVisible);
  const [isCollapsed] = useSideNavCollapse();
  return sideNavVisible ? (isCollapsed ? 84 : 224) : 0;
};
